Directives.NetworkProjectCardDirective = function NetworkProjectCardDirective() {

    // @ngInject
    function NetworkProjectCardDirectiveControllerFunc($scope, $injector, AppStates, CompanyService,
                                                       PopupMessageService,AnalyticsService, NetworkManager, moment) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkProjectCardDirectiveController';
        this.AppStates = AppStates;
        this.CompanyService = CompanyService;
        this.PopupMessageService = PopupMessageService;
        this.AnalyticsService = AnalyticsService;
        this.NetworkManager = NetworkManager;
        this.moment = moment;
        this.currUser = this.NetworkManager.getNetworkCurrUser();

        this.showProjectTypeTag = this.project.project_type !== null && this.project.project_type !== 'other';

        this.deleting = false;

    }

    var NetworkProjectCardDirectiveController = Class(Controllers.BaseController, {

        constructor: NetworkProjectCardDirectiveControllerFunc,

        deleteProject: function deleteProject() {

            var self = this;

            var deleteConfirmed = function deleteConfirmed(){

                self.deleting = true;
                self.analyticsArgs = {
                    projectId : self.project._id
                };

                self.NetworkManager.deleteNetworkProject(self.currUser, self.project._id).then(
                    function success() {
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_deleted_project, self.analyticsArgs);
                    },
                    function error() {
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_deleted_project_error, self.analyticsArgs);
                    }
                ).finally(function done() {
                    self.deleting = false;
                });
            };


            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'NETWORK.PROFILE._CONFIRM_DELETE_',
                deleteConfirmed);
        },

        isProjectEditable: function isProjectEditable(project){
            return (this.currUser._id === this.project.creator._id &&
            this.user._id &&
            this.currUser._id === this.user._id);
        },

        getImageStyle : function getImageStyle(){
            var cover_image = this.project.getCoverPhoto();

            if (cover_image) {
                return {'background-image': 'url(\"//res.cloudinary.com/honeybook/image/upload/h_190,w_280,c_lfill,dpr_auto/' + cover_image.cloudinary_public_id + '.jpg\")'};
            }
        },

        locationDisplayed: function locationDisplayed(project) {
            return project.location ? project.location.replace(', United States', '') : '';
        }
    });

    return {
        scope: {
            project: "=project",
            user: "=user",
            analyticsSource: "=",
            showTimestamp: "="
        },
        templateUrl: 'angular/app/modules/network/features/profile/network_project_card_template.html',
        controller: NetworkProjectCardDirectiveController,
        controllerAs: 'networkProjectCardVm',
        bindToController: true
    };
};
